import type { AnalyticsTracking } from '~/types/redux/share';

const defaultState: Partial<AnalyticsTracking> = {
  shareModalClicked: () => void 0,
};

export default function trackingReducer(
  state: AnalyticsTracking = defaultState as AnalyticsTracking
) {
  return state;
}
